import { useServer } from '@/api/useServerMain'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  // DialogHeader,
  // DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'

import SpinnerLoading from '@/components/misc/SpinnerLoading'
import { useEffect } from 'react'

interface PinProps {
  open: boolean
  onOpenChange: (_open: boolean) => void
  // onSave: (_userData: NewUserPayload) => void
  children?: React.ReactNode
}

export function PinModal({
  open,
  onOpenChange,
  // onSave,
  children,
}: PinProps) {
  const { getTokenTablet, token, isLoading } = useServer()

  useEffect(() => {
    if (open) {
      getTokenTablet()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      {children && <DialogTrigger asChild>{children}</DialogTrigger>}
      <DialogContent className="flex max-h-[90vh] flex-col overflow-hidden sm:max-w-2xl md:max-w-3xl lg:max-w-3xl">
        {/* <DialogHeader>
          <DialogTitle className="text-xl md:text-2xl">{title}</DialogTitle>
        </DialogHeader> */}
        <div className="flex-grow space-y-6 overflow-y-auto px-4 py-4 sm:px-6">
          <div>
            <div className="top-0 z-10 bg-white pb-2 pt-2">
              <h4 className="text-md pt-4 font-medium">
                Se ha generado el siguiente PIN para vincular de forma rápida su
                dispositivo de Punto de Venta. Este código expirará en 5
                minutos.
              </h4>
            </div>

            <div className="flex items-center justify-center py-8">
              {isLoading ? (
                <SpinnerLoading text="Generando token..." />
              ) : (
                <span className="text-6xl font-bold tracking-widest text-gray-900">
                  {token ?? '----'}
                </span>
              )}
            </div>
          </div>
        </div>

        <DialogFooter className="flex flex-col-reverse gap-2 border-t px-4 pt-4 sm:flex-row sm:justify-center sm:px-6">
          <Button onClick={() => onOpenChange(false)} variant="outline">
            Cerrar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
